import React, { Suspense, useState, useEffect } from "react"; 
import Drawer from 'react-modern-drawer';
import { CommonUtilities } from "../../commonUtils";
import projectServices from "../Projects/projectServices";
import { Filter } from "../../filter";
import StatementHistory from "./statementHistory";
import BreackDown from "./BreackDown";
import Email from "../User Profile/Email";
import EmailStatement from "./emailStatement";
import StatementSetting from "./StatementSetting";
import PeriodSelectionForm from "../PeriodSelection/periodSelectionForm";
import { format } from "date-fns";
import ValidateContract from "./validateContract";
import DeleteDialogueBox from "../Common/deleteDialogue";
import QueueMerge from "./queueMerge";
import GenerationAllServices from "./generationAllServices";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function Generation(param: any) {

    const [excel, setexcel] = useState(false);
    const [detail, setdetail] = useState(false);
    const [summary, setsummary] = useState(false);
    const [searchFor, setsearchFor] = useState("");
    const [selectedCount, setselectedCount] = useState(0);
    const [downloadFlag, setdownloadFlag] = useState(false);
    const [reportingEndDate, setreportingEndDate] = useState("");
    const [rightMsgSuccess, setrightMsgSuccess] = useState(false);
    const [openEmailFeed, setopenEmailFeed] = useState(false);
    var [breakDownlist, setBreakDownlist] = useState(false);
    const [openQueueMerge, setopenQueueMerge] = useState(false);
    let [periodSelection, setperiodSelection] = useState(false);
    const [breakDownValue, setBreakDownValue] = useState<any>([]);
    const [openConfirmation, setopenConfirmation] = useState(false);
    const [contractMethodType, setcontractMethodType] = useState("");
    const [EmailFeedDetail, setSEmailFeedDetail] = useState<any>([]);
    const [reportingStartDate, setreportingStartDate] = useState("");
    const [viewPdfMsgSuccess, setviewPdfMsgSuccess] = useState(false);
    const [ConfirmationMessage, setConfirmationMessage] = useState("");
    var [selectedStatement, setSelectedStatement] = useState<any>([]);
    const [downloadMsgSuccess, setdownloadMsgSuccess] = useState(false);
    const [openEmailStatement, setopenEmailStatement] = useState(false);
    const [ProjectStatementCount, setProjectStatementCount] = useState(0);
    const [regenerateMsgSuccess, setregenerateMsgSuccess] = useState(false);
    const [openValidateContract, setopenValidateContract] = useState(false);
    const [openStatementSetting, setopenStatementSetting] = useState(false);
    const [statementHistoryOpen, setStatementHistoryOpen] = useState(false);
    const [ProjectStatementList, setProjectStatementList] = useState<any>([]);
    const [downloadPdfMsgSuccess, setdownloadPdfMsgSuccess] = useState(false);
    const [statementHistoryDetail, setStatementHistoryDetail] = useState<any>([]);
    const [statementSettingDetail, setStatementSettingDetail] = useState<any>([]);
    const [downloadProgressItemMergeFiles, setdownloadProgressItemMergeFiles] = useState(false);

    let sortGenDesc = {
        contractTitle: 0,
        contractRefNum: 0,
        periodNum: 0,
        contractAccount: 0
    };

    var statementPayload = {
        pageNumber: 1,
        pageSize: 10,
        projectId: 7,
        searchFor: searchFor.length > 0 ? searchFor : "",
        resume: statementSettingDetail && statementSettingDetail.resume ? statementSettingDetail.resume : 0,
        contract: statementSettingDetail && statementSettingDetail.contract ? statementSettingDetail.contract : 0,
        contactNoEmail: statementSettingDetail && statementSettingDetail.contactNoEmail ? statementSettingDetail.contactNoEmail : 0,
        periodFrom: reportingStartDate,
        periodTo: reportingEndDate
    }

    var downloadPayload = {
        OrderByFields: 1,
        contactNoEmail: statementSettingDetail && statementSettingDetail.contactNoEmail ? statementSettingDetail.contactNoEmail : 0,
        contract: statementSettingDetail && statementSettingDetail.contract ? statementSettingDetail.contract : 0,
        contractRefNum: "",
        contractTitle: "",
        format: "zip",
        isAll: 0,
        isApproved: 0,
        kontactCode: "",
        kontactDisplay: "",
        listContracts: selectedStatement,
        method: "download",
        periodFrom: reportingStartDate,
        periodTo: reportingEndDate,
        projectCode: param?.projectDetails?.projectCode,
        projectId: param?.projectDetails?.projectId,
        report: "",
        reportType: "",
        resume: statementSettingDetail && statementSettingDetail.resume ? statementSettingDetail.resume : 0,
        searchFor: searchFor.length > 0 ? searchFor : ""
    }
   let [periodSelected, SetperiodSelected] = useState<any>([]);

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        //console.log(periodListCache) 
        for(var i=0 ; i <periodListCache.length ; i++){
            if(periodListCache[i].periodCurrent === 1){
                periodSelected = periodListCache[i]
                SetperiodSelected(periodSelected)
            }
        }
        
        if (param.openGeneration === true) {
            selectedStatement = []
            setSelectedStatement(selectedStatement)
            loadProjectStatementList();
            statementPayload.periodFrom = String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom))
            statementPayload.periodTo = String(Filter.DateTimeFormatNumber(periodSelected?.periodTo))
            setreportingStartDate(String(Filter.DateTimeFormatNumber(periodSelected?.periodFrom)))
            setreportingEndDate(String(Filter.DateTimeFormatNumber(periodSelected?.periodTo)))
        }

    }, [param.openGeneration]);

    const loadProjectStatementList = () => {

        projectServices.getProjectStatementList(statementPayload).then((res) => {
            setProjectStatementList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setProjectStatementCount(res && res.totalRows ? res.totalRows : 0)
            console.log(ProjectStatementList)
        })
    }

    const selectAllContracts = (e: any) => {
        console.log(e)
        if (e === "All") {
            selectedStatement = []
            setSelectedStatement(selectedStatement)
            console.log(ProjectStatementList)
            for (var $i = 0; $i < ProjectStatementList.length; $i++) {
                selectedStatement.push(ProjectStatementList[$i].contractRefNum)
            }
            setSelectedStatement(selectedStatement)
        }

        if (e !== "All") {
            const valueExists = selectedStatement.includes(e);

            console.log(valueExists)
            if (!valueExists) {
                selectedStatement.push(e)
                setSelectedStatement(selectedStatement);
            } else {
                const updatedArray = selectedStatement.filter((item: any) => item !== e);
                console.log(updatedArray)
                setSelectedStatement(updatedArray);
            }

        }
        setselectedCount(selectedStatement.length);
        setSelectedStatement(selectedStatement)
        console.log(selectedStatement)
    }

    const MergeConfirmation = (e: any) => {
        downloadPayload.method = "merge";
        downloadPayload.isApproved = e
        setdownloadProgressItemMergeFiles(true)
        var reportTypeName = ''
        if (excel) {
            reportTypeName = reportTypeName + 'Excel'
        }

        if (detail) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Excel' : 'Excel';
        }

        if (summary) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Summary' : 'Summary';
        }
        downloadPayload.reportType = reportTypeName;
        GenerationAllServices.statementExport(downloadPayload)

        setTimeout(function () {
            setdownloadProgressItemMergeFiles(false);
        }, 3000);
    }

    const downloadProjectReports = (approve: any) => {
        downloadPayload.method = "download";
        downloadPayload.isApproved = approve;
        var reportTypeName = ''
        if (excel) {
            reportTypeName = reportTypeName + 'Excel'
        }

        if (detail) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Excel' : 'Excel';
        }

        if (summary) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Summary' : 'Summary';
        }
        downloadPayload.reportType = reportTypeName;
        GenerationAllServices.statementExport(downloadPayload)
    }

    const approveUnapproveAll = () => {

    }

    const contractRegeneration = () => {

        var reportTypeName = ''
        if (excel) {
            reportTypeName = reportTypeName + 'Excel'
        }

        if (detail) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Excel' : 'Excel';
        }

        if (summary) {
            reportTypeName = reportTypeName.length > 0 ? reportTypeName + '|Summary' : 'Summary';
        }

        var generationPayload = {
            contactNoEmail: statementSettingDetail && statementSettingDetail.contactNoEmail ? statementSettingDetail.contactNoEmail : 0,
            contract: statementSettingDetail && statementSettingDetail.contract ? statementSettingDetail.contract : 0,
            format: "pdf",
            isAll: 0,
            listContracts: selectedStatement,
            method: "view",
            periodFrom: reportingStartDate,
            periodTo: reportingEndDate,
            projectCode: param?.projectDetails?.projectCode,
            reportType: reportTypeName,
            resume: statementSettingDetail && statementSettingDetail.resume ? statementSettingDetail.resume : 0,
            searchFor: searchFor.length > 0 ? searchFor : ""
        }
    }

    const publishToAffiliate = () => {
        var payload = {
            isAll: 0,
            listContracts: selectedStatement,
            periodFrom: reportingStartDate,
            periodTo: reportingEndDate,
            projectCode: param?.projectDetails?.projectCode
        }
        GenerationAllServices.publishToAffiliate(payload)
    }

    const contractMethod = (e: any) => {
        setcontractMethodType(e);
        setopenConfirmation(true);
        if (e === "Generate") {
            setConfirmationMessage("proceed with the generation(s)");
            contractRegeneration();
        }

        if (e === "Affiliate") {
            setConfirmationMessage("publish these contracts to affiliate");
            publishToAffiliate();
        }

        if (e === "Approve") {
            setConfirmationMessage("approve all the contracts selected");
            contractRegeneration();
        }

        if (e === "UnApprove") {
            setConfirmationMessage("unapprove all the contracts selected");
            contractRegeneration();
        }

    }

    const onChange = (period: any) => {

        if (period.periodFrom) {
            console.log(Number(period.periodFrom.year + format(new Date(period.periodFrom.month), 'MMdd')));
        }

        if (period.periodTo) {
            console.log(Number(period.periodTo.year + format(new Date(period.periodTo.month), 'MMdd')));
        }

        if (period && period.action && period.action === 2) {

        }
    }

    const openConfirmationChange = (e: any) => {
        console.log(e)
        setopenConfirmation(false);
    }

    const selectPeriod = (e: any) => {
        periodSelection = true;
        setperiodSelection(periodSelection)
    }

    //* Component Close UI*//
    const closebreakDown = (e: any) => {
        console.log(e)
        breakDownlist = false;
        setBreakDownlist(false)
    }

    const StatementSettingClose = (e: any) => {
        console.log(e)
        setStatementSettingDetail(e);
        setopenStatementSetting(false);
    }

    const closePeriod = (e: any) => {
        console.log(e)
        periodSelection = false;
        setperiodSelection(false)
    }

    const onClose = () => { param.GenerationClose(); }
    const closeEditForm = () => { param.closeEditForm(); }
    const EmailFeedClose = (e: any) => { setopenEmailFeed(false); }
    const EmailStatementClose = () => { setopenEmailStatement(false); }
    const closeValidateContract = () => { setopenValidateContract(false); }
    const closeStatementHistory = () => { setStatementHistoryOpen(false); }

    const closeQueueMerge = (e: any) => {
        console.log(e)
        if (e !== false) {
            downloadPayload.OrderByFields = e;
            MergeConfirmation(0)
        }

        setopenQueueMerge(false)
    }

    return (
        <>
            <Drawer open={param.openGeneration}
                onClose={onClose}
                direction='right'
                className='react-drawer mbl ws-10'
                style={{ width: "100%" }}>

                <div className="box noBorderRadius noBorder ws-11 pull-right">
                    <div className="box-header-main">
                        <h2 className="ws-6"> Generate Statements</h2>
                        <div className="ws-6" style={{ marginTop: "-7px;" }}>
                            <a className="mrl pull-right text-bold white ps text-underline" ng-click="openJobStatus();"> Job Status  </a>
                        </div>
                    </div>

                    <div className="box-content">

                        <div className="ws-12">
                            {viewPdfMsgSuccess && <div className="alert alert-success mb">Generation of Report(s) in process</div>}
                            {downloadPdfMsgSuccess && <div className="alert alert-success mb">Download of Report(s) in process</div>}
                            {downloadFlag && <div className="alert alert-success mb">Operation in process</div>}

                            <div className="ws-3 border-right">
                                <div className="ws-12">
                                    <div className="ws-12 border-bottom mtl" style={{ minHeight: "50px" }}>
                                        <div className="ws-4 label-entries text-left mb"> Project</div>
                                        <label className="ws-8 text-left mts text-bold text-m"> {param?.projectDetails?.projectName} ( {param?.projectDetails?.projectCode}  ) </label>
                                    </div>
                                </div>

                                <div className="ws-12">
                                    <div className="ws-12 border-bottom mtl" style={{ minHeight: "50px" }}>
                                        <div className="ws-4 label-entries text-left mb"> Project Owner</div>
                                        <label className="ws-8 text-left mts text-bold text-m">{param?.projectDetails?.projectOwner} </label>
                                    </div>
                                </div>

                                <div className="ws-12">
                                    <div className="ws-12 pull-left mtl" style={{ minHeight: "50px" }}>
                                        <div className="ws-4 label-entries text-left mb">Project Status</div>
                                        <div className="ws-8 label-entries text-left text-bold ">

                                            <a className="btn-xs m0 mrs" style={{
                                                background: CommonUtilities.lookUpTypeList('projectTag', (CommonUtilities.lookUpTypeListByKey("ProjectStatus", param?.projectDetails?.status, "value")), 'bgColor'),
                                                color: CommonUtilities.lookUpTypeList('projectTag', (CommonUtilities.lookUpTypeListByKey("ProjectStatus", param?.projectDetails?.status, "value")), 'fontColor')
                                            }}>
                                                {CommonUtilities.lookUpTypeListByKey("ProjectStatus", param?.projectDetails?.status, "value")}
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="ws-3 plxl">

                                <div className="ws-6">
                                    <div className="ws-12">
                                        <h2 className="ws-12">Summary</h2>
                                        <button className={summary ? "icon-btn delete mt active" : "icon-btn delete mt"} onClick={() => { setsummary(true) }} >
                                            <i className={summary ? "icon-file-pdf-o text-l  active" : "icon-file-pdf-o text-l "} onClick={() => { setsummary(true) }}></i>
                                        </button>

                                        <button className={summary ? "icon-btn edit mt " : "icon-btn edit mt active"} onClick={() => { setsummary(false) }}>
                                            No
                                        </button>
                                    </div>
                                </div>

                                <div className="ws-12">
                                    <div className="ws-12">
                                        <h2 className="ws-12">Detail</h2>
                                        <button className={detail ? "icon-btn delete mt active" : "icon-btn delete mt"} onClick={() => { setdetail(true) }} >
                                            <i className={detail ? "icon-file-pdf-o text-l  active" : "icon-file-pdf-o text-l "} onClick={() => { setdetail(true) }}></i>
                                        </button>

                                        <button className={detail ? "icon-btn edit mt " : "icon-btn edit mt active"} onClick={() => { setdetail(false) }} >
                                            No
                                        </button>
                                    </div>
                                </div>

                                <div className="ws-12">
                                    <h2 className="ws-12">Excel</h2>
                                    <button className={excel ? "icon-btn edit mt active" : "icon-btn edit mt"} onClick={() => { setexcel(true) }}>
                                        <i className={excel ? "icon-file-excel-o text-l active" : "icon-file-excel-o text-l"}></i>
                                    </button>

                                    <button className={excel ? "icon-btn edit mt " : "icon-btn edit mt active"} onClick={() => { setexcel(false) }} >
                                        No
                                    </button>

                                </div>
                            </div>

                            <div className="ws-2">

                                <div className="ws-12 mtl">
                                    <div className="ws-12">
                                        <div className="ws-8 mr">
                                            <input type="text" value={searchFor} placeholder="Type to search" onChange={(e) => setsearchFor(e.target.value)}
                                                onKeyDown={(e) => e && e.code && e.code === "Enter" ? loadProjectStatementList() : ''} className="m0 heightReset noBorderRadius" />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format ws-12 mt">
                                    <label>Start Date</label>
                                    <div className="label-entries ws-8">
                                        <input type="text" value={reportingStartDate} placeholder="Start Date" readOnly onClick={selectPeriod} />
                                    </div>

                                    <button className="icon-btn edit btn-xs" type="button" onClick={selectPeriod}>
                                        <i className="icon-calendar"></i>
                                    </button>

                                </div>

                                <div className="form-format ws-12 mt">
                                    <label>End Date</label>
                                    <div className="label-entries ws-8">
                                        <input type="text" value={reportingEndDate} placeholder="End Date" readOnly onClick={selectPeriod} />
                                    </div>
                                    <button className="icon-btn edit btn-xs" type="button" onClick={selectPeriod}>
                                        <i className="icon-calendar"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="ws-3">

                                <div className="ws-12">
                                    <div className="ws-12 ml mt pt">
                                        <button className="icon-btn edit pull-right  ws-6 text-center" onClick={() => loadProjectStatementList}> Search </button>
                                    </div>

                                    <div className="ws-12 mtl pt">
                                        <a className="icon-btn edit pull-right  ws-6 m0  text-center" onClick={() => setopenStatementSetting(true)}> Settings </a>
                                    </div>

                                    <div className="hover-box pull-right mtl pt ws-6" ng-hide="downloadMsgSuccess">

                                        <a className="icon-btn edit ws-12 m0 text-center" onClick={() => downloadProjectReports(0)}>
                                            Download
                                            <span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                        </a>

                                        <div className="hover-block mtll" style={{ minWidth: "144px;" }}>
                                            <a className="hover-box icon-btn edit pull-left full-width" onClick={() => downloadProjectReports(1)}>Approved only </a>
                                        </div>

                                    </div>

                                    {downloadMsgSuccess && <button className="icon-btn edit pull-right ml">
                                        <div className="spinnerIcon360"><i className="icon-spinner3"></i></div>
                                    </button>}

                                    <div className="ws-12 mtl ml hide">
                                        <button className="btn icon-btn delete pull-right  ws-6 text-center" onClick={() => loadProjectStatementList}>  Refresh </button>
                                    </div>
                                </div>
                            </div>

                            <hr style={{ border: "1px solid #dde0f5" }} className="ws-12" />

                            <div className="ws-12">

                                <div className="box-content">
                                    {<div className="alert mtl hide" > Enter a criteria and do the search. </div>}
                                    {regenerateMsgSuccess && <div className="alert alert-success">Newer Calc in process </div>}
                                    {downloadProgressItemMergeFiles && <div className="alert alert-success">Merge files download in progress </div>}
                                    {downloadMsgSuccess && <div className="alert alert-success ">Download in progress </div>}

                                    <div className="ws-12 text-bold mbl">
                                        <span className="pull-left mt"> Showing ( {ProjectStatementCount} ) results   </span>
                                        <button className="btn-sm icon-btn delete pull-left" onClick={loadProjectStatementList}>
                                            <i className="icon-refresh2"></i>
                                        </button>
                                    </div>

                                    {rightMsgSuccess && <div className="alert mt">  No adequate permission to generate/approve/email statements  </div>}

                                    <div className="table-responsive_big allowVscroll pt">
                                        <table ng-show="gridDatas.totalRows> 0">
                                            <thead>
                                                <tr>
                                                    <th><input type="checkbox" data-ng-model="selectAllContractsFlag" onClick={() => selectAllContracts("All")} /></th>
                                                    <th ng-click="toggleSorting('contractTitle');" style={{ width: 140 }}> Contract Title
                                                        {sortGenDesc['contractTitle'] === 0 && <span >↕</span>}
                                                        {sortGenDesc['contractTitle'] === 1 && <span >↑</span>}
                                                        {sortGenDesc['contractTitle'] === 2 && <span >↓</span>}
                                                    </th>
                                                    <th ng-click="toggleSorting('contractRefNum');" style={{ width: 140 }}> Contract Code
                                                        {sortGenDesc['contractRefNum'] === 0 && <span >↕</span>}
                                                        {sortGenDesc['contractRefNum'] === 1 && <span >↑</span>}
                                                        {sortGenDesc['contractRefNum'] === 2 && <span >↓</span>}
                                                    </th>
                                                    <th ng-click="toggleSorting('periodNum');"> Period
                                                        {sortGenDesc['periodNum'] === 0 && <span >↕</span>}
                                                        {sortGenDesc['periodNum'] === 1 && <span >↑</span>}
                                                        {sortGenDesc['periodNum'] === 2 && <span >↓</span>}
                                                    </th>
                                                    <th ng-click="toggleSorting('contractAccount');" style={{ width: 140 }}> Contract A/C
                                                        {sortGenDesc['contractAccount'] === 0 && <span >↕</span>}
                                                        {sortGenDesc['contractAccount'] === 1 && <span >↑</span>}
                                                        {sortGenDesc['contractAccount'] === 2 && <span >↓</span>}
                                                    </th>
                                                    <th style={{ width: 200 }}>  </th>
                                                    <th className="forceSingleLine"> Closing Balance</th>
                                                    <th> Calculated</th>
                                                    <th> Generated </th>
                                                    <th> EmaiLive </th>
                                                    <th> Approved Date </th>
                                                    <th> Approval </th>
                                                    <th> Email / Published </th>
                                                    <th style={{ width: 150 }}>  <div className="ws-12"> Reports</div> </th>
                                                    <th> Operations </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ProjectStatementList.map((value: any) => {
                                                    return (
                                                        <tr >
                                                            <td>
                                                                <input type="checkbox" value={selectedStatement.includes(value.contractRefNum)} onClick={() => selectAllContracts(value.contractRefNum)} />

                                                            </td>

                                                            <td>
                                                                <a className="pull-left" ng-click="contractSummary(searchGeneratedStatement);" > {value.contractTitle}  </a>
                                                            </td>

                                                            <td>
                                                                <a className="pull-left" ng-click="contractSummary(searchGeneratedStatement);" >  {value.contractRefNum}  </a>
                                                            </td>

                                                            <td > {value.periodNum} </td>

                                                            <td>
                                                                <span ng-click="insertContact(searchGeneratedStatement)" >{value.contractAccount}</span>
                                                            </td>

                                                            <td>
                                                                <div className="forceSingleLine ws-12">
                                                                    <div className="icon-btn edit btn-sm">
                                                                        <i className="icon-approval" onClick={() => { setBreakDownlist(true); setBreakDownValue(value) }}></i>
                                                                    </div>

                                                                    <a className="icon-btn delete btn-sm ml" target="_blank" href="\assets\statement\cc839a25-c013-46fb-ac47-3b7d6b03c3b9\summary\20240630_Blonde Redhead_111.pdf" ng-show="searchGeneratedStatement.summaryPDF">
                                                                        <i className="icon-file-pdf-o"></i>
                                                                    </a>

                                                                    <button className="icon-btn delete btn-sm ml hide" ng-show="!searchGeneratedStatement.summaryPDF" disabled>
                                                                        <i className="icon-file-pdf-o"></i>
                                                                    </button>

                                                                    <div className="icon-btn edit btn-sm" onClick={() => { setStatementHistoryOpen(true); setStatementHistoryDetail(value); }}> <i className="icon-info1"></i> </div>
                                                                </div>

                                                            </td>

                                                            <td className="text-right"> {value?.closingBalance?.toFixed(2)} </td>

                                                            <td className={value.calDifference === "Correct" ? "bg-level7 " : value.calDifference === "ToCalculate" || value.calDifference === "ReGenerate" ? "bg-level12" : "bg-level3"}>
                                                                {value.calculatedDate && value.calDifference && <span className="text-left white">{Filter.DateTimeFormat(value.calculatedDate)}</span>}
                                                                {!value.calculatedDate && !value.calDifference && <span className="text-bold text-center" style={{ marginLeft: "35% !important;" }}> - </span>}
                                                                {value.calDifference === 'ToCalculate' && <span className="text-left text-bold forceSingleLine white ws-12" style={{ marginLeft: "5% !important;" }}>Not Calculated</span>}
                                                                {value.calDifference === 'ReGenerate' && <span className="text-left text-bold forceSingleLine white ws-12" style={{ marginLeft: "5% !important;" }}>Old Statement</span>}
                                                            </td>

                                                            <td className={value.generatedDate ? "bg-level7" : "bg-level3"}>
                                                                {value.generatedDate && <span style={{ marginLeft: "35% !important;" }} className="text-left white"> {Filter.DateTimeFormat(value.generatedDate)} </span>}
                                                                {!value.generatedDate && <span className="text-bold text-center" style={{ marginLeft: "35% !important;" }}> - </span>}
                                                            </td>

                                                            <td className="bg-level3">
                                                                {value.emailDate && <span style={{ marginLeft: "35% !important;" }} className="text-left white"> {Filter.DateTimeFormat(value.emailDate)}  </span>}
                                                                {!value.emailDate && <span className="text-bold text-center" style={{ marginLeft: "35% !important;" }}> - </span>}
                                                            </td>

                                                            <td className="bg-level3">
                                                                {value.approveDate && <span style={{ marginLeft: "35% !important;" }} className="text-left white"> {Filter.DateTimeFormat(value.approveDate)} </span>}
                                                                {!value.approveDate && <span className="text-bold text-center" style={{ marginLeft: "35% !important;" }}> - </span>}
                                                            </td>

                                                            <td ng-className="approvalColorCode(searchGeneratedStatement.approval)" className="bg-level3">
                                                                {value.approval}
                                                            </td>

                                                            <td ng-className="searchGeneratedStatement.dateEmail ? 'bg-level7 white': 'bg-level3' " className="bg-level3">
                                                                <span ng-if="searchGeneratedStatement.dateEmail === null" className="text-center" style={{ marginLeft: "35% !important;" }}> - </span>
                                                                <button className="icon-btn edit btn-sm pull-right" onClick={() => { setopenEmailFeed(true); setSEmailFeedDetail(value); }}>
                                                                    <i className="icon-mail"></i>
                                                                </button>
                                                            </td>

                                                            <td>
                                                                <div className="ws-12 forceSingleLine">
                                                                    {value.detailExcel && <a className="icon-btn edit btn-sm pull-right" target="_blank" href={value.detailExcel}>
                                                                        <i className="icon-file-excel-o"></i>
                                                                    </a>}
                                                                    {!value.detailExcel && <button className="icon-btn edit btn-sm pull-right" disabled>
                                                                        <i className="icon-file-excel-o"></i>
                                                                    </button>}

                                                                    {value.detailPDF && <a className="icon-btn delete btn-sm pull-right" target="_blank" href={value.detailPDF}>
                                                                        <i className="icon-file-pdf-o"></i>
                                                                    </a>}
                                                                    {!value.detailPDF && <button className="icon-btn delete btn-sm pull-right" disabled>
                                                                        <i className="icon-file-pdf-o"></i>
                                                                    </button>}

                                                                </div>

                                                            </td>

                                                            <td>
                                                                <button className="icon-btn edit btn-sm" ng-click="copyContractToProjects(searchGeneratedStatement, contractProject, false, projectSelected);">
                                                                    Move/Copy
                                                                </button>
                                                            </td>

                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="clearfix">

                                    </div>
                                </div>

                                {ProjectStatementCount > 0 && <div className="box footer pm noBorderRadius">
                                    <button className="icon-btn info pull-right" onClick={() => setopenEmailStatement(true)} disabled={selectedCount === 0}>
                                        Email <span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                    </button>

                                    <div>
                                        <a className="icon-btn info pull-right btn-lg mb ws-3 p0 bg-level3" onClick={approveUnapproveAll}>
                                            <div className="border-right w-45 p8 text-center" style={{ paddingRight: "2px" }} onClick={() => contractMethod("Approve")} >
                                                Approve<span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                            </div>
                                            <div className="w-55 p8 bg-level10 text-center" style={{ paddingLeft: "5px;" }} onClick={() => contractMethod("UnApprove")}>
                                                Un-Approve<span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                            </div>
                                        </a>
                                    </div>

                                    <button className="icon-btn edit pull-right" onClick={() => contractMethod("Generate")} disabled={selectedCount === 0}>
                                        <i className="icon-refresh1"></i>
                                        Generate<span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                    </button>

                                    <button className="icon-btn edit pull-right" ng-show="(((client.host === 'korrect.localhost') || (client.host === 'dev.korrectonline.com') || (client.host === 'artistserve.onkorrect.com') || (client.host === 'qa.onkorrect.com') || (client.host === 'staging.onkorrect.com') || (client.host === 'testaws.beggarsuk.onkorrect.com') || (client.host === 'testaws.beggarsus.onkorrect.com') || (client.host === 'beggarsus.onkorrect.com')|| (client.host === 'beggarsuk.onkorrect.com') || (client.host === 'staging1.onkorrect.com')) ; (gridDatasCount > 0))"
                                        onClick={() => contractMethod("Affiliate")} disabled={selectedCount === 0}>
                                        <i className="icon-save"></i> Publish to Affiliate
                                        <span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                    </button>

                                    <div className="hover-box pull-right" ng-hide="downloadProgressItemMergeFiles">
                                        <i className="icon-approval hide"></i>

                                        <a className="icon-btn edit" onClick={() => setopenQueueMerge(true)}>
                                            Merge Files <span style={{ color: "#27AE60 !important" }}> ( {selectedCount} ) </span>
                                        </a>

                                        <div className="hover-block mtll" style={{ minWidth: "144px;" }}>
                                            <a className="hover-box icon-btn edit pull-left btn-app full-width" onClick={() => MergeConfirmation(1)}>
                                                Approved only
                                            </a>
                                        </div>
                                    </div>

                                    <button className="icon-btn edit btn pull-right" onClick={() => { setopenValidateContract(true); }}>
                                        Validate Contracts
                                    </button>

                                    {downloadProgressItemMergeFiles && <button className="icon-btn edit pull-right">
                                        <div className="spinnerIcon360"><i className="icon-spinner3"></i></div>
                                    </button>}

                                </div>}

                                <div className="box footer pm noBorderRadius">
                                    <button className="icon-btn delete pull-right" onClick={closeEditForm}> Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {(() => {
                    if (statementHistoryOpen) {
                        return <StatementHistory open={statementHistoryOpen} closeStatementHistory={closeStatementHistory} type="projectGeneration" statementHistoryDetail={statementHistoryDetail} />
                    }

                    if (breakDownlist) {
                        return <BreackDown open={breakDownlist} values={breakDownValue} closebreakDown={closebreakDown} project={param.projectDetails} />;
                    }

                    if (openEmailFeed) {
                        return <Email openEmailFeed={openEmailFeed} EmailFeedClose={EmailFeedClose} />;
                    }

                    if (openEmailStatement) {
                        return <EmailStatement openEmailStatement={openEmailStatement} EmailStatementClose={EmailStatementClose} />;
                    }

                    if (openStatementSetting) {
                        return <StatementSetting openStatementSetting={openStatementSetting} StatementSettingClose={StatementSettingClose} projectDetails={param.projectDetails} />;
                    }

                    if (periodSelection === true) {
                        return <PeriodSelectionForm open={periodSelection} closePeriod={closePeriod} onChange={onChange} periodFrom={Filter.convertToDateString(reportingStartDate)} periodTo={Filter.convertToDateString(reportingEndDate)} />;
                    }


                    if (openValidateContract) {
                        return <ValidateContract openValidateContract={openValidateContract} closeValidateContract={closeValidateContract} projectDetails={param.projectDetails} />;
                    }

                    if (openConfirmation) {
                        return <DeleteDialogueBox param={true} message={ConfirmationMessage} onChange={openConfirmationChange} />
                    }

                    if (openQueueMerge) {
                        return <QueueMerge openQueueMerge={openQueueMerge} closeQueueMerge={closeQueueMerge} />
                    }

                })()}

            </Drawer>
        </>
    )
}